import { Discount, Price, PriceInterval } from '@griply/types';
import { httpsCallable } from 'firebase/functions';
import { getErrorReporter } from 'shared/services/error-tracking';

import { getFunctions } from './helpers';

const intervalOrder = [
  PriceInterval.Month,
  PriceInterval.Year,
  PriceInterval.Lifetime,
];

type PricesResponse = { prices: Price[]; discount: Discount | null };

// the SDK reports a failed fetch as `internal` too; the online tag tells the two apart in Sentry
const fetchPrices = async (): Promise<PricesResponse> => {
  const getPrices = httpsCallable<undefined, PricesResponse>(
    getFunctions(),
    'stripe-getPricesForUser',
  );
  try {
    const { data } = await getPrices();
    return data;
  } catch (error: unknown) {
    getErrorReporter().captureException(error, {
      tags: {
        source: 'stripe-get-prices-for-user',
        online: String(window.navigator.onLine),
      },
    });
    throw error;
  }
};

export const getSubscriptionPrices = async () => {
  const data = await fetchPrices();

  const sortedPrices = data.prices.sort((priceA, priceB) => {
    const priceAIndex = intervalOrder.indexOf(priceA.interval);
    const priceBIndex = intervalOrder.indexOf(priceB.interval);

    if (priceAIndex === -1) {
      return 1;
    }

    if (priceBIndex === -1) {
      return -1;
    }

    return priceAIndex - priceBIndex;
  });

  return { prices: sortedPrices, discount: data.discount };
};
